import { BlockWidthContext, useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { Box, Typography } from '@mui/material';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

var getCardWidth = function getCardWidth(containerWidth) {
  return function (theme) {
    return containerWidth === 0 ? 0 : "calc(100% / ".concat(Math.floor(containerWidth / 300), " - ").concat(theme.spacing(3), ")");
  };
};

export var CardList = function CardList(_ref) {
  var items = _ref.items,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? /*#__PURE__*/_jsx(Typography, {
    children: "There are no items to show."
  }) : _ref$fallback;
  var containerWidth = useContext(BlockWidthContext);
  var isMobile = useContainerMediaQuery({
    maxWidth: 'md'
  });
  return /*#__PURE__*/_jsx(Box, {
    style: {
      display: containerWidth > 0 ? 'flex' : 'none',
      flexWrap: 'wrap',
      rowGap: '24px',
      marginRight: isMobile ? 0 : '-24px'
    },
    "data-element": "Box",
    "data-component": "CardList",
    "data-source-file": "index.tsx",
    children: pipe(items, O.fromPredicate(A.isNonEmpty), O.matchW(function () {
      return fallback;
    }, A.map(function (item) {
      return /*#__PURE__*/_jsx(Box, {
        sx: {
          mr: isMobile ? 0 : 3,
          width: isMobile ? '100%' : getCardWidth(containerWidth)
        },
        children: item
      }, item.key);
    })))
  });
};